<div class="container mx-auto p-6 flex flex-col gap-4">
  <!-- Resource Header -->
  @if (ressource) {
    <div class="">
      <h1 class="text-4xl font-extrabold font-alice">{{ressource.nom}}</h1>
      <div class="text-gray-600">
        <p class="text-lg"><strong>Type:</strong> {{ressource.type}}</p>
        @if (ressource.nom_musique) {
          <p class="text-lg"><strong>Nom de la musique:</strong> {{ressource.nom_musique}}</p>
        }
      </div>
      <div class="prose max-w-none">
        <p>{{ressource.description}}</p>
      </div>
    </div>
  }

  <!-- Audio Section -->
  @if (audioFiles.length > 0) {
    <div class="">
      <h2 class="text-2xl font-bold mb-4">Audio</h2>
      <div class="border rounded-lg">
        @for (file of audioFiles; track file) {
          <div class="border-b p-4 flex flex-row gap-2 items-center">
            <p class="text-md font-raleway font-semibold">{{file.nom}}</p>
            <audio controls class="w-full">
              <source [src]="file.url" type="audio/mpeg">
              Votre navigateur ne supporte pas la lecture audio.
            </audio>
          </div>
        }
      </div>
    </div>
  }

  <!-- PDF Section -->
  @if (pdfFiles.length > 0) {
    <div class="">
      <h2 class="text-2xl font-bold mb-4">Documents</h2>
      <div class="space-y-4">
        @for (file of pdfFiles; track file) {
          <div class="border rounded-lg p-4">
            <h3 class="text-lg font-semibold mb-2">{{file.nom}}</h3>
            @if (file.viewUrl) {
              <iframe [src]="file.viewUrl" [title]="'Document : ' + file.nom" class="w-full" style="height:600px;"></iframe>
            }
            <a [href]="file.url" target="_blank" rel="noopener noreferrer"
              class="mt-2 inline-block text-sm font-semibold text-primary underline">
              Ouvrir « {{file.nom}} » dans un nouvel onglet
            </a>
          </div>
        }
      </div>
    </div>
  }

  <!-- YouTube Section -->
  @if (youtubeVideos.length > 0) {
    <div class="">
      <h2 class="text-2xl font-bold mb-4">Vidéos</h2>
      <div class="space-y-4">
        @for (video of youtubeVideos; track video) {
          <div class="border rounded-lg p-4">
            <h3 class="text-lg font-semibold mb-2">{{video.nom}}</h3>
            <div class="relative" style="padding-bottom: 56.25%;">
              <div class="absolute top-0 left-0 w-full h-full">
                <app-consent-embed service="youtube" [title]="'Vidéo : ' + video.nom" [src]="video.embedUrl"
                  [fallbackUrl]="video.url" fallbackLabel="Voir sur YouTube"></app-consent-embed>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
